import { fromJS } from 'immutable';

export function finish(state, { marketTemplateId, selection }) {
    const path = [ 'items', marketTemplateId, 'selections' ];

    return state.setIn(path, state.getIn(path).push(fromJS(selection)));
}
